import {Redirect, Route, Router, Switch} from "react-router-dom";
import {useEffect, useState} from "react";
import Header from "../components/header/Header";
import $ from 'jquery'
import history from "../utils/History";
import Nav from "../components/Nav/Nav";
import ElencoAssistentiFamiliari from "./registro/ElencoAssistentiFamiliari";
import WizardRegistro from "./registro/WizardRegistro/WizardRegistro";
import ElencoUtenti from "./utenti/ElencoUtenti";
import ElencoSportelli from "./sportelli/ElencoSportelli";
import Footer from "../components/Footer/Footer";
import Interceptor from "../services/Interceptor";
import auth from "../../src/utils/AthnAuth";
import globals from '../config/appconfig'
import authConfig from "../config/authConfig";
import Faq from "./faq/Faq";
import Termini from "./termini/Termini";
import Privacy from "./privacy/Privacy";
import DoveSiamo from "./doveSiamo/DoveSiamo";
import Home from "./home/Home";
import CercaAssistentiFamiliari from "./home/CercaAssistentiFamiliari";
import Report from "./report/Report";
import {useDispatch} from "react-redux";
import {deleteAssistente, deleteStateUpload} from "../actions/IndexActions";
import Login from "./login/Login";
import Spinner from "../components/spinner/Spinner";
import SchedaAssistente from "./schedaAssistente/SchedaAssistente";
import LogoutOrNotAuthorized from "./LogoutOrNotAuthorized/LogoutOrNotAuthorized";
import LoginCallback from "./login/LoginCallback";
import Annunci from "./annunci/Annunci";
import WizardAnnuncio from "./annunci/WizardAnnuncio/WizardAnnuncio";
import SelezioneSportello from "./selezioneSportello/SelezioneSportello";
import Utils from "../utils/Utils";
import AnagraficaService from "../services/AnagraficaService";
import stylesRouteRAF from "./RouteRAF.module.css";
import ModaleScadenzaSessione from "../components/ModaleScadenzaSessione/ModaleScadenzaSessione";

auth.configurazione({
    auth: authConfig['attivazione-auth'],
    urlAthn: new URL(authConfig['url-redirect-auth']).origin,
    applicationId: "RAF",
    samlTokenErrorFunction: (code, description) => {
        let mess = "Si e verificato un problema nell'accedere ai servizi infrastrutturali (come ad esempio l'anagrafica). Contattare l'Helpdesk per sistemare la posizione fornendo il codice errore "+code+" - "+description
        // ToasterSingleton.instance().aggiuntaToaster({
        //     type: "confirm", //in caso di problemi nel recuperare il tipo di toaster, lo mostro come errore
        //     text: [mess],
        //     timestamp: Date.now()
        // });
    },
    samlTokenResources: [`${globals["app-url-backend-anagrafica"]}/anagraficheAndCandidati`]
});

/* WCAG 2.2.1: appiglio per il collaudo dell'avviso di scadenza sessione.
   Espone il singleton di autenticazione affinche' sia possibile abbassare i tempi
   da console e osservare la modale senza attendere un'ora, es.:
     auth.impostaTempiSessione({inattivita: 30000, preavviso: 20000})
   Escluso dalla build di produzione: il singleton di autenticazione non deve
   essere raggiungibile da window nell'ambiente di esercizio.
   Si usa REACT_APP_ENV e non NODE_ENV perche' react-scripts forza NODE_ENV a
   "production" durante il build, sovrascrivendo il valore passato da cross-env. */
if (typeof window !== "undefined" && process.env.REACT_APP_ENV?.trim() !== "PRODUCTION") {
    window.auth = auth;
}
function RouteRAF(props) {
    const [url, setUrl] = useState(window.location.pathname);
    const [showSpinner,setShowSpinner] = useState(false)
    const dispatch = useDispatch()
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}
    const nazioniPerCodice = JSON.parse(sessionStorage.getItem("nazioniPerCodice"))
    const provincePerCodice = JSON.parse(sessionStorage.getItem("provincePerCodice"))
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice"))
    const siglaProvincePerCodice = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    Utils.alert()
    useEffect( ()=>{
        setShowSpinner(true)
        new Interceptor()
        auth.recuperoSessione()
            .then(utente => {
                if (utente) {
                    if (!utente.gruppi) {
                        // Guard: su page refresh recuperoSessione può tornare utente con gruppi undefined.
                        // Se la sessione è già stabilita non ripetiamo il setup.
                        const sessioneSalvata = JSON.parse(sessionStorage.getItem("sessioneUtente") || "{}")
                        if (sessioneSalvata.loggedIn) {
                            setShowSpinner(false)
                            return
                        }

                        setShowSpinner(true)
                        AnagraficaService.getCandidatoByCodiceFiscale({ codiceFiscale: utente.codiceFiscale })
                            .then(res => {
                                // Trovato → è un Assistente Familiare
                                if (!res.data || res.data.length === 0) {
                                    throw new Error("Nessun candidato trovato per il codice fiscale fornito")
                                }
                                const id = res.data[0].id
                                const nuovaSessione = {
                                    sessionId: "",
                                    codiceFiscale: utente.codiceFiscale,
                                    nome: utente.nome,
                                    cognome: utente.cognome,
                                    ruolo: "RAF-AF",
                                    sportelli: null,
                                    struttura: utente.codiceStruttura,
                                    tipoUtente: "02",
                                    loggedIn: true
                                }
                                sessionStorage.setItem("sessioneUtente", JSON.stringify(nuovaSessione))
                                auth.setSessioneUtente(nuovaSessione)
                                Utils.recuperaDatiAssistente(id, dispatch, history, "/annunci",
                                    comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, provincePerCodice)
                                setShowSpinner(false)
                            })
                            .catch(error => {
                                // Non trovato → RAF-FAM
                                if (error.response && error.response.status !== 404) {
                                    console.error("Errore HTTP durante il recupero dati candidato:", error)
                                } else if (!error.response && !(error.message && error.message.includes("Nessun candidato"))) {
                                    console.error("Errore di rete durante il recupero dati candidato:", error)
                                }
                                const nuovaSessione = {
                                    sessionId: "",
                                    codiceFiscale: utente.codiceFiscale,
                                    nome: utente.nome,
                                    cognome: utente.cognome,
                                    ruolo: "RAF-FAM",
                                    sportelli: null,
                                    struttura: utente.codiceStruttura,
                                    tipoUtente: "04",
                                    loggedIn: true
                                }
                                sessionStorage.setItem("sessioneUtente", JSON.stringify(nuovaSessione))
                                auth.setSessioneUtente(nuovaSessione)
                                history.push({ pathname: "/annunci" })
                                setShowSpinner(false)
                            })
                        return  // esce dal then di recuperoSessione; il flusso prosegue nei callback sopra
                    }
                    let ok = Utils.checkStringInArray(utente.gruppi)
                    if (ok) {
                        /* Sessione presente PRIMA di questo giro di autenticazione.
                           Va letta qui, perche' poche righe sotto sessionStorage viene
                           sovrascritto con la sessione nuova: e' il discriminante fra
                           primo accesso (redirect al punto d'ingresso) e ricaricamento
                           di pagina a sessione gia' stabilita (l'utente resta dov'e').
                           Stesso criterio della guardia sul ramo senza gruppi, sopra. */
                        const sessionePrecedente = JSON.parse(sessionStorage.getItem("sessioneUtente") || "{}")
                        let sessioneUtente = {
                            sessionId: "",
                            codiceFiscale: utente.codiceFiscale,
                            nome: utente.nome,
                            cognome: utente.cognome,
                            ruolo: utente.gruppi,
                            sportelli: utente.sportelli,
                            struttura: utente.codiceStruttura,
                            tipoUtente: utente.gruppi.includes("RAF-AF") ? "02" : "01",
                            loggedIn: true
                        };
                        sessionStorage.setItem("sessioneUtente",JSON.stringify(sessioneUtente))
                        auth.setSessioneUtente(sessioneUtente)
                        let jsonParam = {
                            idReport: 5
                        }
                        Utils.putReport(jsonParam)

                        if (sessioneUtente.tipoUtente === "01" || sessioneUtente.tipoUtente === "02") {
                            let jsonParam = {
                                idReport: 4,
                                ruolo: sessioneUtente.ruolo
                            }
                            Utils.putReport(jsonParam)
                        }
                        /* Era "if (!sessioneUtente.loggedIn)", condizione morta: sessioneUtente
                           e' l'oggetto costruito qui sopra con loggedIn:true fisso, quindi la
                           negazione era sempre falsa e il redirect non veniva mai eseguito.
                           L'utente restava sulla schermata "Verifica autenticazione in corso"
                           pur avendo ottenuto i token. Si valuta invece la sessione precedente:
                           assente al primo accesso (si redirige), presente al refresh (si resta). */
                        if (!sessionePrecedente.loggedIn) {
                            if (sessioneUtente.tipoUtente === "01") {
                                history.push({
                                    pathname: "/selezioneSportello"
                                })
                            } else {
                                Utils.recuperoDatiSintesiCandidato(sessioneUtente.codiceFiscale, dispatch, history, setShowSpinner, "/profilo",comuniPerCodice,siglaProvincePerCodice,nazioniPerCodice, provincePerCodice)
                            }
                        }
                    } else {
                        let sessioneUtente = {
                            loggedIn: false,
                            tipoUtente: "03"
                        };
                        sessionStorage.setItem("sessioneUtente",JSON.stringify(sessioneUtente))
                        let path = new URL(authConfig["url-unauthorized"]).pathname;
                        history.push({pathname: path});
                    }
                    setShowSpinner(false)
                }
            }).catch((error) => {
            console.log("Not signed in");
            console.error(`Errore: ${error}`);
        });
        setShowSpinner(false)
    },[])

    useEffect(() => {
        setShowSpinner(true)
        if(url !== "/wizardRegistro" && sessioneUtente && sessioneUtente.tipoUtente === "01"){
            dispatch(deleteAssistente())
            dispatch(deleteStateUpload())
        }
        setShowSpinner(false)
    },[url])

    useEffect(() => {
        const unlisten = history.listen((location) => {
            setUrl(location.pathname);
            if (localStorage.getItem("scroll") !== "false") {
                window.scrollTo(0, 0);
            } else {
                $('html, body').animate({scrollTop: $(document).height()}, 1);
                localStorage.setItem("scroll", "true");
            }
        });
        return () => unlisten();
    }, []);

    return (
                <Router history={history}>
                    <Spinner show={showSpinner}/>
                    {/* WCAG 2.2.1: avviso di scadenza sessione con possibilita' di
                        prolungamento. Montato qui una sola volta perche' vale per tutta
                        l'area autenticata; il componente si autodisattiva per gli utenti
                        anonimi (tipoUtente "03" / loggedIn false). */}
                    <ModaleScadenzaSessione/>
                    <Switch>
                        <Route exact path="/" render={() => (<Redirect to="/home"/>)} />
                        <Route render={() => (
                            <div>
                                <a className={stylesRouteRAF.skipLink} href="#contenuto-principale">Salta al contenuto principale</a>
                                <Header/>
                                {window.location.pathname === "/login" || window.location.pathname === "/selezioneSportello"?<></>:<Nav/>}
                                <main id="contenuto-principale">
                                <Route exact path='/home' render={() => (
                                    <div><Home/></div>
                                )}/>
                                <Route exact path='/login' render={() => (
                                    <div><Login/></div>
                                )}/>
                                <Route exact path='/registro' render={() => (
                                    <div><ElencoAssistentiFamiliari/></div>
                                )}/>
                                <Route exact path='/utenti' render={() => (
                                    <div><ElencoUtenti/></div>
                                )}/>
                                <Route exact path='/sportelli' render={() => (
                                    <div><ElencoSportelli/></div>
                                )}/>
                                <Route exact path='/wizardRegistro' render={() => (
                                    <div><WizardRegistro/></div>
                                )}/>
                                <Route exact path='/profilo' render={() => (
                                    <div><WizardRegistro/></div>
                                )}/>
                                <Route exact path='/profiloAssistente' render={() => (
                                    <div><SchedaAssistente/></div>
                                )}/>
                                <Route exact path='/faq' render={() => (
                                    <div><Faq/></div>
                                )}/>
                                <Route exact path='/termini' render={() => (
                                    <div><Termini/></div>
                                )}/>
                                <Route exact path='/privacy' render={() => (
                                    <div><Privacy/></div>
                                )}/>
                                <Route exact path='/cercaAssistenteFamiliare' render={() => (
                                    <div><CercaAssistentiFamiliari/></div>
                                )}/>
                                <Route exact path='/doveSiamo' render={() => (
                                    <div><DoveSiamo/></div>
                                )}/>
                                <Route exact path='/report' render={() => (
                                    <div><Report/></div>
                                )}/>
                                <Route exact path='/annunci' render={() => (
                                    <div><Annunci/></div>
                                )}/>
                                <Route exact path='/wizardAnnuncio' render={() =>
                                    sessioneUtente?.tipoUtente === "04"
                                        ? <div><WizardAnnuncio/></div>
                                        : <Redirect to="/annunci"/>
                                }/>
                                <Route exact path='/unauthorized' render={() => (
                                    <LogoutOrNotAuthorized />
                                )}/>
                                <Route exact path='/login-callback' render={() => (
                                    <LoginCallback/>
                                )}/>
                                <Route exact path='/selezioneSportello' render={() => (
                                    <SelezioneSportello/>
                                )}/>
                                </main>
                                <Footer style={{position:window.location.pathname === "/unauthorized" || window.location.pathname === "/login-callback"?"fixed":"absolute",bottom:window.location.pathname === "/unauthorized"|| window.location.pathname === "/login-callback"?"0":""}}/>
                            </div>
                        )}/>
                    </Switch>
                </Router>
    );
}

export default RouteRAF;
